import { ICreateKEMembershipPageModel } from '../../../../../../models/interfaces/Membership/KidnapAndExtortion/CreateKEMembershipPageModel';

export const checkFamilyMembersFormVisible = (
  values: ICreateKEMembershipPageModel,
) =>
  values &&
  values.membershipPlanId &&
  values.membershipPlanId.maxMembersPerPlan > 1;
